module.exports = __webpack_public_path__ + "assets/img/kv-b50e1864.jpg";